import { getDefaultItemNameEditorState } from './reducers';
import { ItemNameEditorsState, ItemNameEditorState } from './typings';

export const selectItemNameEditorValue = (editors: ItemNameEditorsState, editorId: string): ItemNameEditorState => {
    return editors[editorId] || getDefaultItemNameEditorState();
};
